import React, { PureComponent } from "react";
import "./clinic.css";

export default class Clinic extends PureComponent {
    static get defaultProps() {
        return {
            name: null,
            address: null,
        };
    }

    static get propTypes() {
        return {
            name: React.PropTypes.string,
            address: React.PropTypes.string,
        };
    }

    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    render() {
        return (
            <div className="appointment-clinic">
                    {this.props.name !== null ? <div className="appointment-clinic__name">
                        {this.props.name}
                    </div> : null}

                    {this.props.address !== null ? <div className="appointment-clinic__address">
                        {this.props.address}
                    </div> : null}
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/components/clinic.js
 **/